import { Box, Button, Card, CircularProgress, Tab, Tabs, TextField, Typography, makeStyles } from '@material-ui/core'
import { FlexHorizontal, IBoard, MessageCard, Spacer } from '@vestaboard/installables'
import React, { useEffect, useState } from 'react'
import { useHistory, useParams } from 'react-router'

import { Alert } from '@material-ui/lab'
import { Check } from '@material-ui/icons'
import { ListFeedAppearances } from '../components/ListFeedAppearances'
import { ListMessageAppearances } from '../components/ListMessageAppearances'
import { ListMessageFavorites } from '../components/ListMessageFavorites'
import { ListMessageFlags } from '../components/ListMessageFlags'
import { ListMessageSets } from '../components/ListMessageMessageSets'
import { MessageTags } from '../components/MessageTags'
import { useCreateMessage } from '../hooks/useCreateMessage'
import { useGetMessage } from '../hooks/useGetMessage'

const useStyles = makeStyles({
  cardInner: {
    padding: 20
  }
})

interface IGetMessage {
  messageId?: string
  onUpdateTags?: (id: string, tags: string[]) => void
}

export const GetMessage = (props: IGetMessage) => {
  const classes = useStyles()
  const params = useParams<{ id: string }>()
  const id = props?.messageId || params.id
  const isCharacters = id?.includes('[[')
  const { data, loading, error } = useGetMessage(id, {
    skip: isCharacters
  })
  const [createMessage] = useCreateMessage()
  const [tab, setTab] = useState(0)
  const [copied, setCopied] = useState(false)
  const history = useHistory()

  const handleCopyCharacters = () => {
    navigator.clipboard.writeText(JSON.stringify((data?.message as any)?.characters))
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }

  useEffect(() => {
    if (isCharacters) {
      createMessage({
        variables: {
          input: {
            characters: JSON.parse(decodeURIComponent(id))
          }
        }
      }).then(res => {
        if (res.data?.createMessage.__typename === 'MessageV2') {
          history.push(`/message/${res.data?.createMessage.id}`)
        }
      })
    }
  }, [createMessage, history, id, isCharacters])

  return error ? (
    <Alert severity='error'>There was an error loading the message</Alert>
  ) : loading ? (
    <CircularProgress />
  ) : data?.message.__typename === 'MessageErrorV2' ? (
    <Alert severity='error'>{data.message.error}</Alert>
  ) : (
    <>
      <FlexHorizontal spaceBetween>
        <Typography variant='h4'>Message</Typography>
      </FlexHorizontal>
      <Spacer size='large' />
      <Card>
        <Box className={classes.cardInner}>
          {data?.message?.cardSize === '15x3' ? (
            <Box display='flex' alignItems='center' marginBottom='24px'>
              <Check color='secondary' />
              <Box width={7} />
              <Typography color='secondary'>Note Compatible</Typography>
            </Box>
          ) : null}
          <TextField value={data?.message.id} disabled label='ID' variant='outlined' fullWidth />
          <Spacer size='large' />
          <TextField value={data?.message.text} disabled label='Text' variant='outlined' fullWidth />
          <Spacer size='large' />
          <Box width={400}>
            <MessageCard
              boardStyle={data?.message?.cardSize === '15x3' ? 'note-black' : 'black'}
              characters={data?.message?.characters as IBoard}
            />
          </Box>
          <Spacer size='medium' />
          <Button variant='outlined' onClick={handleCopyCharacters}>
            {copied ? 'Copied!' : 'Copy Character Array'}
          </Button>
          <MessageTags tags={data?.message?.tags || []} messageId={id} onUpdateTags={props.onUpdateTags} />
        </Box>
      </Card>
      <Spacer size='extraLarge' />
      <FlexHorizontal spaceBetween>
        <Tabs
          value={tab}
          onChange={(_event, newValue) => {
            setTab(newValue)
          }}>
          <Tab label='Feed Appearances' id='feed' key='feed' />
          <Tab label='Board Appearances' id='board' key='board' />
          <Tab label='Favorites' id='favorite' key='favorite' />
          <Tab label='Message Sets' id='messageSets' key='messageSets' />
          <Tab label='Flags' id='flag' key='flag' />
        </Tabs>
      </FlexHorizontal>
      <Spacer size='large' />
      {tab === 0 ? (
        <ListFeedAppearances messageId={id} />
      ) : tab === 1 ? (
        <ListMessageAppearances messageId={id} />
      ) : tab === 2 ? (
        <ListMessageFavorites messageId={id} />
      ) : tab === 3 ? (
        <ListMessageSets messageId={id} />
      ) : (
        <ListMessageFlags messageId={id} />
      )}
    </>
  )
}
